export default function (epochTime) {
  const different = (epochTime * 1000) - Date.now()
  return different < 93600000 && different > 0
}